import { AlertType } from '@ge/models/constants';

export const CommissioningTemplate = {
  _id: '19d078d0-0bab-11ec-9a03-0242ac130003',
  alertType: AlertType.COMMISSIONING_OUTAGE,
  entrypoint: 'string',
  sections: [
    {
      collapsed: false,
      hidden: false,
      metadata: {
        block: {
          position: {
            col: 1,
            row: 1,
            span: 12,
          },
          type: 'blockedActions',
          values: ['Block Cases', 'Block Commands'],
        },
        contactInfo: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 4,
            span: 12,
          },
          type: 'text',
        },
        requestedBy: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
          },
          position: {
            col: 1,
            row: 2,
            span: 5,
          },
          type: 'text',
        },
        requestedTime: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          defaultSelection: 'currentDate',
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          position: {
            col: 1,
            row: 2,
            span: 7,
          },
          type: 'dateTime',
        },
      },
      type: 'body',
    },
    {
      collapsed: true,
      hidden: false,
      metadata: {
        description: {
          create: {
            readOnly: false,
            required: false,
          },
          edit: {
            readOnly: false,
            required: false,
          },
        },
      },
      type: 'description',
    },
    {
      collapsed: true,
      hidden: false,
      metadata: {
        sendNotification: {
          create: {
            readOnly: false,
            required: false,
          },
          edit: {
            readOnly: false,
            required: false,
          },
        },
      },
      type: 'send_notification',
    },
  ],
  operations: ['create', 'edit'],
  tenantId: 'dfsa',
};

export const CommissioningMailTemplate = {
  bcc: 'CommissioningBCC@mock.com',
  cc: 'CommissioningCC@mock.com',
  body: '',
  header: 'This is to inform of a Commissioning for {{siteName}} – {{assetName}}',
  maxAttachments: 5,
  maxAttachmentSizeMb: 10,
  subject: 'Commissioning  Notifications for {{siteName}} – {{assetName}}',
  to: '',
};
